import axios from 'axios';

// CSV mode: the next blob request gets ?download_format=csv; the saved file's extension then
// follows the server's reply (.csv for one sheet, .zip of CSVs for multi-sheet workbooks).
let armed = false;
let armTimer = null;
let pendingExt = null;

axios.interceptors.request.use((config) => {
  if (armed && config.responseType === 'blob') {
    armed = false;
    config.params = { ...(config.params || {}), download_format: 'csv' };
    config.csvExport = true;
  }
  return config;
});

axios.interceptors.response.use((res) => {
  if (res.config?.csvExport) {
    const t = String(res.headers?.['content-type'] || '');
    pendingExt = t.includes('zip') ? 'zip' : t.includes('csv') ? 'csv' : null;
  }
  return res;
});

const origClick = HTMLAnchorElement.prototype.click;
HTMLAnchorElement.prototype.click = function patchedClick(...args) {
  if (pendingExt && this.download && /\.xlsx?$/i.test(this.download)) {
    this.download = this.download.replace(/\.xlsx?$/i, `.${pendingExt}`);
    pendingExt = null;
  }
  return origClick.apply(this, args);
};

export const withCsv = async (fn) => {
  armed = true;
  pendingExt = null;
  clearTimeout(armTimer);
  armTimer = setTimeout(() => { armed = false; }, 3000);
  const r = fn();
  if (!r || typeof r.then !== 'function') return r;
  try { return await r; } finally { armed = false; }
};
